module.exports = __webpack_public_path__ + "static/media/advantages_bar_left.672b8189.svg";